import { Provider } from "@angular/core"
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core"
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from "@angular/material/form-field"
import { MatSnackBarConfig, MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar"
import { MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from "@angular/material/tooltip"
import { UTCLuxonDateAdapter } from "../../adapter/luxon-date-adapter/utc-luxon-date-adapter"


const appearance: MatFormFieldDefaultOptions = {
    appearance: 'outline',
}

const tooltipOptions: MatTooltipDefaultOptions = {
    showDelay: 400,
    hideDelay: 200,
    touchendHideDelay: 2000,
    position: 'right'
}

const snackbarOptions: MatSnackBarConfig = {
    verticalPosition: 'bottom',
    horizontalPosition: 'right',
    duration: 6000,
    panelClass: 'snack-panel'
}

export const MATProviders: Provider [] = [
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: appearance,
    },
    {
        provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
        useValue: tooltipOptions
    },
    {
        provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
        useValue: snackbarOptions
    },
    {
        provide: DateAdapter, useClass: UTCLuxonDateAdapter
    },
    {
        provide: MAT_DATE_LOCALE,
        useValue: 'ca'
    },
    {
        provide: MAT_DATE_FORMATS,
        useValue: {
            parse: {
                dateInput: 'dd/MM/yyyy',
            },
            display: {
                dateInput: 'dd/MM/yyyy',
                monthYearLabel: 'MMMM yyyy',
                dateA11yLabel: 'dd/MM/yyyy',
                monthYearA11yLabel: 'MMMM yyyy',
            }
        }
    }
]